// Leading icons for the quotation editor's layout-mode dropdown (#1311). One per Apryse layout
// mode, drawn to the design's four page glyphs: one page, two pages stacked with a vertical
// offset, two pages side by side, and a 2x2 block.
//
// 16x16 on a 1.2 stroke to match the rest of the viewer's menu iconography; they inherit
// `currentColor` so a disabled menu row greys the icon along with its label.

type Props = { className?: string }

const PAGE_STROKE = {
	stroke: "currentColor",
	strokeWidth: 1.2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
} as const

export const LayoutSinglePageIcon = ({ className }: Props) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<path d="M9.5 1.8H4.2a1 1 0 0 0-1 1v10.4a1 1 0 0 0 1 1h7.6a1 1 0 0 0 1-1V5.1L9.5 1.8Z" {...PAGE_STROKE} />
		<path d="M9.4 2v2.2a1 1 0 0 0 1 1h2.2" {...PAGE_STROKE} />
	</svg>
)

export const LayoutContinuousPagesIcon = ({ className }: Props) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<rect x="3.4" y="1.4" width="9.2" height="5.6" rx="1" {...PAGE_STROKE} />
		<rect x="3.4" y="9" width="9.2" height="5.6" rx="1" {...PAGE_STROKE} />
	</svg>
)

export const LayoutFacingIcon = ({ className }: Props) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<rect x="1.4" y="3.4" width="5.6" height="9.2" rx="1" {...PAGE_STROKE} />
		<rect x="9" y="3.4" width="5.6" height="9.2" rx="1" {...PAGE_STROKE} />
	</svg>
)

export const LayoutFacingContinuousIcon = ({ className }: Props) => (
	<svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
		<rect x="1.4" y="1.4" width="5.6" height="5.6" rx="1" {...PAGE_STROKE} />
		<rect x="9" y="1.4" width="5.6" height="5.6" rx="1" {...PAGE_STROKE} />
		<rect x="1.4" y="9" width="5.6" height="5.6" rx="1" {...PAGE_STROKE} />
		<rect x="9" y="9" width="5.6" height="5.6" rx="1" {...PAGE_STROKE} />
	</svg>
)
